import axios from 'axios';
import { user } from '../store';
import apiClientConfig from './config';

const API = apiClientConfig[process.env.NODE_ENV || 'development'];
const PLATFORM = {
  plat: 'wa',
  plat_name: 'gzzd'
};

const MP_PLATFORM = {
  plat: 'wp',
  plat_name: 'wxgzj'
};


const WXB_PLATFORM = {
  plat: 'wa',
  plat_name: 'wxb'
};

export type Method = 'GET' | 'POST' | 'PUT' | 'DELETE';

export interface APIConfig {
  defaultToken?: string;
}

async function apiRequest(
  method: Method,
  url: string,
  data: any,
  config: APIConfig
) {
  let requestData = data;
  let params = data;

  if (method === 'GET') {
    requestData = null;
  } else {
    params = null;
  }

  const token = user.token;

  const response = await axios(url, {
    data,
    headers: {
      token
    },
    method,
    params
  });

  if (response.data.status === 80003) {
    user.login();
  }

  return response.data;
}

function createClient(
  method: Method,
  url: string,
  defaultData: any = {},
  defaultConfig: APIConfig = {}
) {
  return (data?: any, apiConfig: APIConfig = {}) => {
    const config = {
      ...defaultConfig,
      ...apiConfig
    };

    const requestData = {
      ...defaultData,
      ...data
    };

    return apiRequest(method, url, requestData, config);
  };
}

function createBaseClient(
  method: Method,
  url: string,
  defaultData: any = {},
  defaultConfig: APIConfig = {}
) {
  return createClient(method, API.BASE_HOST + url, defaultData, defaultConfig);
}

function createStudyClient(
  method: Method,
  url: string,
  defaultData: any = {},
  defaultConfig: APIConfig = {}
) {
  return createClient(method, API.STUDY_HOST + url, defaultData, defaultConfig);
}

const apiClient = {
  base: {
    /**
     * 资产信息
     * 0041
     */
    account: createBaseClient('GET', '/v1/account', PLATFORM),
    /**
     * 资产信息-维修宝
     * 0041
     */
    wxbAccount: createBaseClient('GET', '/v1/account', WXB_PLATFORM),
    // 0066 - 登录
    login: createBaseClient('POST', '/v1/member', { action: 'login' }),
    // 0011.2 - 授权登录
    oauth: ({ route = '', mp = '' } = { route: '', mp: '' }) => {
      // 记录用户进行了 oauth 操作，以便后续决定是否要接受 token
      localStorage.setItem('oauth', 'true');

      const host = route
        ? window.location.host + route
        : window.location.host + window.location.pathname;

      let plat = '';
      let platName = '';

      if (mp) {
        plat = 'wp';
        platName = mp;
      }

      const url =
        API.OAUTH_URL +
        `?host=${encodeURIComponent(host)}&plat_name=${platName}&plat=${plat}`;

      window.location.href = url;
    },
    /**
     * 购买积分
     *  0126
     */
    purchaseScores: createBaseClient('GET', '/v1/score', MP_PLATFORM),
    /**
     * 积分配置
     * 0165
     *
     */
    scoresConfig: createBaseClient('GET', '/v1/config'),
    /**
     * 积分充值列表
     * 0125
     */
    scoresRechargeList: createBaseClient('GET', '/v1/score', PLATFORM),
    /**
     * 积分充值列表
     * 0125
     */
    scoresRechargeListWxb: createBaseClient('GET', '/v1/score', WXB_PLATFORM),
    /**
     * 积分充值列表-维修宝
     * 0125
     */
    wxbScoresRechargeList: createBaseClient('GET', '/v1/score', WXB_PLATFORM),
    /**
     * 积分记录-维修宝
     * 0044
     */
    wxbScoresRecord: createBaseClient('GET', '/v1/account', WXB_PLATFORM),
    /**
    *0081-会员列表-维修工之家
    **/
    vipProducts: createStudyClient('GET', '/v1/vip'),
    // 0061 - 用户信息-维修工之家
    wxbUserinfo: createBaseClient('GET', '/v1/member', MP_PLATFORM),
    // 0061 - 用户信息-快修宝
    kxbUserinfo: createBaseClient('GET', '/v1/member', WXB_PLATFORM),
    /*
    * 0082-购买会员-维修工之家
    */
    purchaseMember: createStudyClient('GET', '/v1/vip',MP_PLATFORM),
    /**
     * 0017-购买咨询
     */
    consultBuy: createStudyClient('GET', '/v1/expert' ,{...MP_PLATFORM, action: 'buy'}),
    /**
     * 0083-会员信息
     */
    wxbMemberInfo: createStudyClient('GET', '/v1/vip', {
      action: 'info',
    }),

    // 0061 - 用户信息
    userinfo: createBaseClient('GET', '/v1/member', PLATFORM),
    // 0015 - 微信签名
    weixinSign: createBaseClient('GET', '/v1/weixin', MP_PLATFORM),








    /**
     * 0171-专区列表
     */
    getCourseTag: createStudyClient('GET', '/v1/course', {action: 'tag'}),
    /**
     * 0172-课程列表
     * page, lid, tid, keywords
     * 0173-课程详情
     * id
     */
    getCourse: createStudyClient( 'GET', '/v1/course' ),
    /**
     * 0174-购买课程
     * id
     */
    buyCourse: createStudyClient('GET', '/v1/course', {...MP_PLATFORM, action: 'buy'}),
    /**
     * 0175-已购列表
     * page
     */
    mineCourse: createStudyClient('GET', '/v1/course', { action: 'mine' }),
    /**
     * 0183-观看进度
     * id, second
     */
    videoProgress: createStudyClient('POST', '/v1/video'),
    /**
     * 0181-视频列表
     * page, cid
     */
    videoList: createStudyClient('GET', '/v1/video'),
    /**
     * 0182-视频详情
     * id
     */
    videoDetail: createStudyClient('GET', '/v1/video'),
    /**
     * 0178-预告登记
     * id, phone
     */
    reserveCourse: createStudyClient( 'POST', '/v1/course' ),

  }
};

export default apiClient;
